import type { IFormContainerResolve } from "App/Modules/Services";

export class ConfirmationModalComponentController {
    public static $inject: string[] = ["$scope"];

    public resolve: IFormContainerResolve<boolean, string>;

    public confirmationEntity: string;

    public $onInit() {
        this.confirmationEntity = this.resolve.bindings;
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel(false);
        }
    }

    public onOk() {
        if (this.resolve.options.onOk) {
            this.resolve.options.onOk(true);
        }
    }
}
